import {Alert, Button} from "inferno-bootstrap";
import {T} from "inferno-i18next";
import {Level} from "../../utils/types";

export function BlockNotification(props: { level: Level, message: string, accept?: () => void, acceptText?: string, dismiss?: () => void, dismissText?: string }) {
    return (
        <div className="position-fixed loader d-flex flex-column justify-content-center notification">
            <Alert color={props.level} className="d-flex flex-wrap shadow m-3 align-items-center justify-content-between">
                <div class="p-1">
                    <T i18nKey={props.message}>X</T>
                </div>
                <div class="p-1">
                    {props.acceptText &&
					<Button color={Level.Primary} onClick={props.accept}>
						<T i18nKey={props.acceptText}>x</T></Button>}
                    {props.dismissText &&
					<Button className="ml-2" outline color={Level.Primary} onClick={props.dismiss}>
						<T i18nKey={props.dismissText}>x</T></Button>}
                </div>
            </Alert>
        </div>
    );
}
